'use client'

import React, { use, useEffect, useState } from 'react'
import classNames from 'classnames'
import { cn } from '@/utils/ui'
import { Card, CardProps } from '@/ui/components/Card'
import { PaginatedDocs } from 'payload'

type ItemsGridProps = {
  dataPromise: Promise<PaginatedDocs<CardProps>>
  className?: string
  /** Items to display in the archive */
  /** Function to render each item as a card */
  gridCols?: 1 | 2 | 3 | 4
  preserveItems?: boolean
}

export const ItemsGrid = ({
  dataPromise,
  className: classNameFromProps,
  gridCols = 3,
  preserveItems = false,
}: ItemsGridProps) => {
  const data: PaginatedDocs<CardProps> = use(dataPromise)
  const [items, setItems] = useState<CardProps[]>([])
  const [pagesLoaded, setPagesLoaded] = useState<number>(0)

  useEffect(() => {
    if (preserveItems === true && items) {
      setItems((prev) => [...prev, ...data.docs])
      if (data.page && data.page <= pagesLoaded) return
      setPagesLoaded((prev) => prev + 1)
    } else {
      setItems(data.docs)
    }
  }, [data])

  return (
    <div className={classNames(classNameFromProps, '@container/grid')}>
      <div className={cn('grid', getGridColumnClass(gridCols))}>
        {items.map((doc, index) => (
          <React.Fragment key={index}>
            <Card {...doc} className={'h-full'} />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export const getGridColumnClass = (cols: 1 | 2 | 3 | 4): string => {
  const gridColumnClasses = {
    1: 'grid-cols-1 gap-2',
    2: 'grid-cols-1 @lg/grid:grid-cols-2 gap-5',
    3: 'grid-cols-1 @lg/grid:grid-cols-2 @3xl/grid:grid-cols-3 gap-5',
    4: 'grid-cols-1 @lg/grid:grid-cols-2 @3xl/grid:grid-cols-3 @5xl/grid:grid-cols-4 gap-5 @3xl/grid:gap-3 @5xl/grid:gap-5',
  }
  return gridColumnClasses[cols]
}
